import axiosInstance from '../lib/axios'
import { API_ENDPOINTS } from '../constants/api'
import type { Printer, PrinterCreate, PrinterUpdate, PrinterListResponse } from '../types/api.types'

export const printersService = {
  // property_id is required by the API.
  async getAll(propertyId: number): Promise<Printer[]> {
    const url = `${API_ENDPOINTS.PRINTERS}?property_id=${propertyId}`
    const { data } = await axiosInstance.get<PrinterListResponse | Printer[]>(url)
    // ponytail: the handoff doc doesn't say whether the list is enveloped like
    // tables ({ tables, total }) or bare like devices. Accept either rather than
    // guessing — callers get an array. Drop the branch once the shape is known.
    return Array.isArray(data) ? data : (data.printers ?? [])
  },

  async create(printer: PrinterCreate): Promise<Printer> {
    const { data } = await axiosInstance.post<Printer>(API_ENDPOINTS.PRINTERS, printer)
    return data
  },

  // PATCH, not PUT — matches every other /restaurant resource.
  async update(id: number, printer: PrinterUpdate): Promise<Printer> {
    const { data } = await axiosInstance.patch<Printer>(API_ENDPOINTS.PRINTER_BY_ID(id), printer)
    return data
  },

  async delete(id: number): Promise<void> {
    await axiosInstance.delete(API_ENDPOINTS.PRINTER_BY_ID(id))
  },
}
